import PropTypes from 'prop-types'
import React from 'react'

import MobileNavAccordion from './MobileNavAccordion'
import MobileNavFooterLink from './MobileNavFooterLink'

const MobileNav = ({accordions, footerColumns}) => (
  <nav className="mobile-nav">
    <div className="mobile-nav-inner">
      <div className="mobile-nav-links">
        <div className="mobile-nav-accordions">
          {accordions.map((accordion) => (
            <MobileNavAccordion key={accordion.title} data={accordion} />
          ))}
        </div>
        <div className="mobile-nav-footer">
          {footerColumns.map((links) => (
            <ul className="mobile-nav-footer-column" key={links[0].title}>
              {links.map((link) => (
                <MobileNavFooterLink key={link.title} data={link} />
              ))}
            </ul>
          ))}
        </div>
      </div>
    </div>
  </nav>
)

MobileNav.propTypes = {
  accordions: PropTypes.arrayOf(
    PropTypes.shape({
      links: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
  footerColumns: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        toSpa: PropTypes.bool.isRequired,
        url: PropTypes.string.isRequired,
      }),
    ),
  ).isRequired,
}

export default MobileNav
